import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Region } from './dtos/region';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { EsbForm as EsbForm } from './dtos/esbForm';

@Injectable({ providedIn: 'root' })
export class RegionsService {
  private regionsUrl = this.baseUrl + '/api/regions';

  public constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    @Inject('API_BASE_URL') private baseUrl: string
  ) {}

  public getAllBasicInfo(): Observable<Region[]> {
    return this.http
      .get<Region[]>(this.regionsUrl + '/GetAllBasicInfo')
      .pipe(catchError(this.handleError<Region[]>('getAllBasicInfo')));
  }

  public getRegion(id: string): Observable<Region> {
    return this.http
      .get<Region>(this.regionsUrl + '/Get/' + id)
      .pipe(catchError(this.handleError<Region>('get')));
  }

  public addRegion(code: string, name: string): Observable<string> {
    return this.http
      .post<string>(this.regionsUrl + '/Add', { code, name })
      .pipe(
        tap(() => this.toastr.success('Saved Sucessfully')),
        catchError(this.handleError<string>('updateRegion'))
      );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public updateRegion(id: string, code: string, name: string): Observable<any> {
    return this.http
      .put(this.regionsUrl + '/Update/' + id, { id, code, name })
      .pipe(
        tap(() => this.toastr.success('Saved Sucessfully')),
        catchError(this.handleError<Region>('updateRegion'))
      );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public deleteRegion(regionId: string): Observable<any> {
    return this.http.delete(this.regionsUrl + '/Delete/' + regionId).pipe(
      tap(() => this.toastr.success('Deleted Sucessfully')),
      catchError(this.handleError<Region>('deleteRegion'))
    );
  }

  public addRegionEsb(payload: EsbForm): Observable<string> {
    return this.http.post<string>(this.regionsUrl + '/AddEsb', payload).pipe(
      tap(() => this.toastr.success('Saved Sucessfully')),
      catchError(this.handleError<string>('addRegionEsb'))
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public updateRegionEsb(payload: EsbForm): Observable<any> {
    return this.http
      .put(
        this.regionsUrl +
          '/UpdateEsb/' +
          payload.locationId +
          '/' +
          payload.esbId,
        payload
      )
      .pipe(
        tap(() => this.toastr.success('Saved Sucessfully')),
        catchError(this.handleError<Region>('updateRegionEsb'))
      );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public deleteRegionEsb(regionId: string, esbId: string): Observable<any> {
    return this.http
      .delete(this.regionsUrl + '/DeleteEsb/' + regionId + '/' + esbId)
      .pipe(
        tap(() => this.toastr.success('Deleted Sucessfully')),
        catchError(this.handleError<Region>('deleteRegionConnection'))
      );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
  private handleError<T>( operation = 'operation', result?: T | undefined): (err: any) => Observable<T> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (error: any): Observable<T> => {
      console.error('An error occurred', error);
      this.toastr.error(`${operation} failed: ${error.message}`);

      throw error;
    };
  }
}
